import _ from 'lodash'
import type {CompRef, Pointers, VariantPointer} from '@wix/document-services-types'
import type {DAL} from '@wix/document-manager-core'
import {removePrefix} from '@wix/document-manager-utils'
import {VARIANTS} from '../../../../constants/constants'

export const getMobileBreakpoint = (dal: DAL, pointers: Pointers, compRef: CompRef): VariantPointer | undefined => {
    const breakpointsDataVariants = _.filter(
        pointers.data.getVariantDataItemsByComponentId(compRef.id),
        variant => variant.type === VARIANTS.VARIANT_TYPES.BREAKPOINTS_DATA
    )

    if (breakpointsDataVariants.length) {
        const {breakpointVariantPointer} = breakpointsDataVariants[0].values.reduce(
            (currentMinimalBreakpointData: {pointer: CompRef; max: string}, breakpointId: string) => {
                const variantPointer = pointers.data.getVariantsDataItem(removePrefix(breakpointId, '#'), compRef.id)
                const breakpointVariantData = dal.get(variantPointer)

                if (!currentMinimalBreakpointData.max || breakpointVariantData.max < currentMinimalBreakpointData.max) {
                    return {
                        breakpointVariantPointer: variantPointer,
                        max: breakpointVariantData.max
                    }
                }

                return currentMinimalBreakpointData
            }
        )
        return breakpointVariantPointer
    }
}
